export type InvoiceLineTrackingType = 'default' | 'manual' | 'composed_work' | 'text' | 'product_import' | 'duplicate';
export type InvoiceLineReorderType = 'drag' | 'move_up' | 'move_down';
export type InvoicePreviewSource = 'form' | 'detail_modal';
export type InvoiceSectionSource = 'blank' | 'library';

export default function useInvoiceTracking() {
    const { $tracker } = useNuxtApp();

    const trackLineAdded = (documentType: string | undefined, lineType: InvoiceLineTrackingType, linesCount = 1) => {
        $tracker.track('invoicing_invoice_line_added', {
            document_type: documentType,
            line_type: lineType,
            lines_count: linesCount,
        });
    };

    const trackLineReordered = (documentType: string | undefined, reorderType: InvoiceLineReorderType, crossSection = false) => {
        $tracker.track('invoicing_invoice_line_reordered', {
            document_type: documentType,
            reorder_type: reorderType,
            cross_section: crossSection,
        });
    };

    const trackPreviewed = (documentType: string | undefined, source: InvoicePreviewSource) => {
        $tracker.track('invoicing_invoice_previewed', {
            document_type: documentType,
            source,
        });
    };

    const trackSaved = (documentType: string | undefined, isNew: boolean) => {
        $tracker.track('invoicing_invoice_saved', {
            document_type: documentType,
            is_new: isNew,
        });
    };

    const trackSectionAdded = (documentType: string | undefined, source: InvoiceSectionSource) => {
        $tracker.track('invoicing_invoice_section_added', {
            document_type: documentType,
            source,
        });
    };

    const trackPageBreakAdded = (documentType: string | undefined) => {
        $tracker.track('invoicing_invoice_page_break_added', {
            document_type: documentType,
        });
    };

    return { trackLineAdded, trackLineReordered, trackPreviewed, trackSaved, trackSectionAdded, trackPageBreakAdded };
}
